<div *ngIf="hasPreviewPermission && msges.length > 0" class="chatMessagePreview">
  <div *ngFor="let typingMessage of msges" [ngClass]="typingMessage.isFromCustomer() ? 'blue_div' : 'black_div'" aria-hidden="true">
    <div class="left" [ngClass]="typingMessage.isFromCustomer() ? 'cng-ico_client_div' : 'cng-ico_agent_div'" aria-hidden="true">
      <div class="rounded">
        <span [ngClass]="typingMessage.isFromCustomer() ? 'cng-ico_user' : 'cng-ico_agent'"></span>
      </div>
    </div>
    <div class="system-message-content">
      <div class="interlocutor-fullName">
        <span *ngIf="typingMessage.isFromCustomer()">
          <span *ngIf="typingMessage.firstName && typingMessage.lastName">
            {{ typingMessage.firstName }} {{ typingMessage.lastName }}
          </span>
          <span *ngIf="!(typingMessage.firstName && typingMessage.lastName)">{{
            'agent:contact.info.unknown_contact' | translate | uppercase
          }}</span>
        </span>
        <span *ngIf="!typingMessage.isFromCustomer()">
          <span *ngIf="typingMessage.firstName && typingMessage.lastName">
            {{ typingMessage.firstName }} {{ typingMessage.lastName }}
          </span>
        </span>
      </div>
      <p [innerHTML]="getMessageContent(typingMessage.content)">
        <span class="blinking-cursor">|</span>
      </p>
    </div>
  </div>
</div>
<div *ngIf="!hasPreviewPermission" id="preview">
  <div *ngIf="msges.length > 1">
    <span class="cng-ico_chat_envoi" title="{{ 'agent:panel.chat.typing' | translate }}"></span>
    <span class="chat-typing-message">
      <span>{{ 'agent:panel.chat.typing' | translate }}</span>
    </span>
  </div>
  <div *ngIf="msges.length === 1">
    <span class="cng-ico_chat_envoi" title="{{ 'agent:panel.chat.typing' | translate }}"></span>
    <span class="chat-typing-message">
      <span *ngIf="msges[0].firstName && msges[0].csrId"> {{ msges[0].firstName }} {{ 'agent:panel.chat.typing' | translate }} </span>
      <span *ngIf="firstName && !msges[0].csrId"> {{ firstName }} {{ 'agent:panel.chat.typing' | translate }} </span>
      <span *ngIf="(!firstName && !msges[0].csrId) || (!msges[0].firstName && msges[0].csrId)">
        {{ 'agent:contact.info.unknown_contact' | translate }} {{ 'agent:panel.chat.typing' | translate }}
      </span>
    </span>
  </div>
</div>
